
























































import { Vue, Component } from 'vue-property-decorator'
import CAudio from './component/CAudio.vue'
import { getDetailA } from '@/server/phpApi'
import { constants } from 'http2'
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
])
@Component({
  components: {
    CAudio,
  },
})
export default class Detail extends Vue {
  detail: any = {
    mobile: '',
    record_slice: '',
    grade_name: '',
    audio_url: '',
  }
  recordList: any = []
  isBack: boolean = true
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name !== 'customerlist') {
        vm.$data.isBack = false
      }
    })
  }
  handleGoBack() {
    if (this.isBack) {
      this.$router.back()
    } else {
      this.$router.push('/customerlist')
    }
  }
  getDetail(id: string, date: string) {
    getDetailA({
      id,
      date,
    }).then(res => {
      if (res.errcode === 0) {
        const resData = res.data
        console.log(resData,55555)
        this.detail.mobile = resData.mobile
        this.detail.audio_url = resData.audio_url
        this.detail.record_slice = resData.record_slice
        for (let i = 0; i < resData.record_slice.length; i++) {
          resData.record_slice[i].playing = false
        }
        this.recordList = resData.record_slice
      }
    })
  }

  handleLoadedMetaData(audioRef: string, item: any, index: number) {
    const audio: any = this.$refs[audioRef]
    const audioNode = audio[0]
    const currentTime = item.offset / 1000
    const duration = item.duration / 1000
    const endTime = item.end
    audioNode.currentTime = currentTime
    audioNode.addEventListener('timeupdate', () => {
      if (audioNode.currentTime > endTime) {
        audioNode.pause()
        this.recordList[index].playing = false
      }
    })
    console.log(currentTime,duration,endTime)
  }
  turnApartIconPaused() {
    for (let i = 0; i < this.recordList.length; i++) {
      this.recordList[i].playing = false
    }
  }
  handleWholeStart() {
    const audioNodes: any = document.getElementsByClassName('part-audio')
    for (let i = 0; i < audioNodes.length; i++) {
      audioNodes[i].pause()
    }
    this.turnApartIconPaused()
  }
  handlePlayApart(audioRef: string, item: any, index: number) {
    const audio: any = this.$refs[audioRef]
    const audioNode = audio[0]
    const currentTime = item.offset / 1000
    const duration = item.duration / 1000
    audioNode.currentTime = currentTime
    this.turnApartIconPaused()
    if (audioNode.paused) {
      const allAudio = document.getElementsByTagName('audio')
      for (let i = 0; i < allAudio.length; i++) {
        allAudio[i].pause()
      }
      audioNode.play()
      this.recordList[index].playing = true
    } else {
      audioNode.pause()
      this.recordList[index].playing = false
    }
  }
  created() {
    const id = this.$route.params.id
    const date = this.$route.params.call_time
    this.getDetail(id, date)
  }
}
